import(/* webpackMode: "eager" */ "/opt/stpi-client/src/app/(index)/group/[id]/[team_id]/page.tsx");
